import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

type UpdateEventCategoriesInput = {
  eventId: number;
  categoryIds: number[];
};

type UpdateEventCategoriesResponse = {
  ok: boolean;
  event: {
    id: number;
  };
};

const UPDATE_EVENT_CATEGORIES_MUTATION = gql`
  mutation UpdateEventCategories($input: UpdateEventCategoriesInput!) {
    updateEventCategories(input: $input) {
      ok
      event {
        id
      }
    }
  }
`;

const eventCategoriesApi = {
  updateEventCategories: async ({
    eventId,
    categoryIds
  }: UpdateEventCategoriesInput): Promise<UpdateEventCategoriesResponse> => {
    return gqlClient
      .request<{ updateEventCategories: UpdateEventCategoriesResponse }>(
        UPDATE_EVENT_CATEGORIES_MUTATION,
        { input: { eventId, categoryIds } }
      )
      .then((res) => res.updateEventCategories);
  }
};

export { eventCategoriesApi };
